import { useCallback } from "react";
import { useHistory } from "react-router-dom";
import { useAuthStore } from "stores/authStore/authStore";
import { useChatStore } from "web-apps/company/stores/chatStore/chatStore";
import { useCompanyStore } from "web-apps/company/stores/companyStore/companyStore";

/**
 * Shared company sign-out flow used by navigation components.
 */
export const useSignOut = () => {
  const history = useHistory();
  const [, authActions] = useAuthStore();
  const [, chatDispatch] = useChatStore();
  const [, , companyDispatch] = useCompanyStore();

  return useCallback(
    async (afterSignOut?: () => void): Promise<void> => {
      try {
        await authActions.signOut();
        companyDispatch({ type: "CLEAR_COMPANY_INFORMATION" });
        chatDispatch({ type: "CLEAR_CHAT_DATA" });
        history.push("/company/login");
        afterSignOut?.();
      } catch (error) {
        console.error("Sign out failed", error);
      }
    },
    [authActions, chatDispatch, companyDispatch, history],
  );
};
